export default "__VITE_ASSET__8db5f32d__"